export default {
      id: "external-link-usage",
      viewBox: "0 0 12 13",
      url: __webpack_public_path__ + "img/icons.31feac93.svg#external-link",
      toString: function () {
        return this.url;
      }
    }